import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
export default class index extends Component {
    render() {
        return (
            <div className="footer-body-box">
                <Container fluid={true}>
                    <Row>
                        <Col xs={10}>
                            <div>Ask Our Executive for No Cost EMI Offer</div>
                        </Col>
                        <Col className="pr-0"> 
                            <img src={`${publicRuntimeConfig.staticFolder}/images/close.png`} alt="Tag close" className="tag-close float-right" onClick={this.props.disabledFooter} />
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}
